// ClipDescriptionModal.jsx
import React, { useState } from "react";

export function ClipDescriptionModal({
  isOpen,
  onClose,
  onSave,
  inTime,
  outTime,
  loading
}) {
  const [description, setDescription] = useState("");

  if (!isOpen) return null;

  // Format time for display (MM:SS)
  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const duration = outTime - inTime;

  const handleSave = () => {
    onSave(description);
    setDescription("");
  };

  const handleClose = () => {
    setDescription("");
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={handleClose}
      />

      {/* Modal */}
      <div className="relative bg-jp-field border border-jp-line rounded-lg shadow-xl w-full max-w-md mx-4 p-5">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-jp-ink">Save Time</h3>
          <button
            onClick={handleClose}
            className="text-jp-muted hover:text-jp-ink transition-colors"
            disabled={loading}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Time Info */}
        <div className="bg-jp-section rounded-lg p-3 mb-4">
          <div className="grid grid-cols-3 gap-3 text-center">
            <div>
              <p className="text-[10px] text-jp-muted uppercase tracking-wide mb-1">In Time</p>
              <p className="text-sm font-mono text-green-400">{formatTime(inTime)}</p>
            </div>
            <div>
              <p className="text-[10px] text-jp-muted uppercase tracking-wide mb-1">Out Time</p>
              <p className="text-sm font-mono text-red-600 dark:text-red-400">{formatTime(outTime)}</p>
            </div>
            <div>
              <p className="text-[10px] text-jp-muted uppercase tracking-wide mb-1">Duration</p>
              <p className="text-sm font-mono text-blue-400">{formatTime(duration)}</p>
            </div>
          </div>
        </div>

        {/* Description Input */}
        <div className="mb-4">
          <label className="block text-sm text-jp-muted mb-2">
            Title / Description <span className="text-jp-muted/80">(optional)</span>
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Add a description for this clip time..."
            className="w-full bg-jp-field border border-jp-line rounded-lg px-3 py-2 text-sm text-jp-ink placeholder-jp-muted/70 focus:outline-none focus:border-blue-500 resize-none"
            rows={3}
            disabled={loading}
          />
        </div>

        {/* Actions */}
        <div className="flex gap-3">
          <button
            onClick={handleClose}
            className="flex-1 px-4 py-2 text-sm font-medium text-jp-muted bg-jp-section hover:bg-jp-line border border-jp-line rounded-lg transition-colors"
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="flex-1 px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-500 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="h-4 w-4 rounded-full border-2 border-jp-line border-t-white animate-spin" />
                Saving...
              </>
            ) : (
              "Save"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
